import { createReducer } from "typesafe-actions";

import GlobalSearchItem from "../../types/globalSearch/GlobalSearchItem";

import {
  Actions,
  fetchUserRecents,
  hideGlobalSearch,
  performSearch,
  resetActiveQuery,
  showGlobalSearch,
} from "./actions";

export interface GlobalSearchState {
  activeQuery: string;
  loading: boolean;
  searchResult: GlobalSearchItem[];
  userRecents: GlobalSearchItem[];
  visible: boolean;
}

const initialState: GlobalSearchState = {
  activeQuery: "",
  loading: false,
  searchResult: [],
  userRecents: [],
  visible: false,
};

const globalSearch = createReducer<GlobalSearchState, Actions>(initialState)
  .handleAction(fetchUserRecents.request, (state) => ({
    ...state,
    loading: true,
  }))
  .handleAction(fetchUserRecents.success, (state, { payload }) => ({
    ...state,
    loading: false,
    userRecents: payload,
  }))
  .handleAction(fetchUserRecents.failure, (state) => ({
    ...state,
    loading: false,
  }))
  .handleAction(showGlobalSearch, (state) => ({
    ...state,
    visible: true,
  }))
  .handleAction(hideGlobalSearch, (state) => ({
    ...state,
    activeQuery: "",
    visible: false,
  }))
  .handleAction(resetActiveQuery, (state) => ({
    ...state,
    activeQuery: "",
  }))
  .handleAction(performSearch.request, (state, { payload }) => ({
    ...state,
    activeQuery: payload.query,
    loading: true,
  }))
  .handleAction(performSearch.success, (state, { payload }) => ({
    ...state,
    loading: false,
    searchResult: payload,
  }))
  .handleAction(performSearch.failure, (state) => ({
    ...state,
    loading: false,
  }));

export type GlobalSearchActions = Actions;
export default globalSearch;
